import { EventEmitter } from 'events';
import dispatcher from './dispatcher';
import {
  VIEW_LOGIN_ID,
  VIEW_LOGIN_ID_ERR,
  LOADING,
  SUCCESS,
  DISMISS,
  VIEW_STUDENTS,
} from './Actions';

class StudentStore extends EventEmitter {
  constructor() {
    super();
    this.loginIDs = [];
    this.loading = false;
    this.generated = false;

    this.students = [];
  }

  initialState() {
    this.loading = false;
    this.generated = false;
  }

  getLoginID() {
    return this.loginIDs;
  }

  generatedStatus() {
    return {
      loading: this.loading,
      generated: this.generated,
    };
  }

  getAllStudents() {
    return this.students;
  }

  handleActions(action) {
    switch (action.type) {
      case VIEW_LOGIN_ID:
        this.loginIDs = action.payload;
        this.emit('change');
        break;
      case VIEW_LOGIN_ID_ERR:
        this.emit('error');
        break;
      case VIEW_STUDENTS:
        this.students = action.payload;
        this.emit('change');
        break;

      case LOADING:
        this.loading = true;
        this.generated = false;
        this.emit('change');
        break;
      case SUCCESS:
        this.loading = false;
        this.generated = true;
        this.emit('change');
        break;
      case DISMISS:
        this.initialState();
        this.emit('change');
        break;
    }
  }
}

const studentStore = new StudentStore();

dispatcher.register(studentStore.handleActions.bind(studentStore));

export default studentStore;
